/* Elite Vitality homepage — swipe rail progress bars */
(function () {
  if (window.__evRails) return;
  window.__evRails = true;
  function bind(root) {
    (root || document).querySelectorAll('[data-ev-rail]').forEach(function (rail) {
      if (rail.__evBound) return;
      rail.__evBound = true;
      var bar = rail.parentElement.querySelector('.ev-progress span');
      if (!bar) return;
      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        var share = rail.clientWidth / rail.scrollWidth;
        var w = Math.max(share, 0.12);
        bar.style.width = (w * 100) + '%';
        var p = max > 0 ? rail.scrollLeft / max : 0;
        bar.style.transform = 'translateX(' + (p * (1 / w - 1) * 100) + '%)';
      }
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); });
  else bind();
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
